<div *ngIf="!readOnly">
  <div class="tag-panel-container">
    <div *ngFor="let tagCol of tagColumns">
      <p-panel
        [style]="{ 'margin-bottom': '1em', height: '100%', 'min-width': '110px' }"
        header="{{ tagCol.name }}"
        class="tag-panel"
        (click)="onTagsClicked(tagCol.index, $event)"
      >
        <div
          *ngFor="let tag of tagSet[tagCol.index]"
          [ngClass]="{ 'tag-name-inactive': tag.tagEntity.inactiveDate != null }"
          class="tag-name"
        >
          {{ tag.tagEntity.name }}
        </div>
      </p-panel>
    </div>
  </div>
  <p-dialog
    #tagSelectorDialog
    header="Select Tag(s)"
    [(visible)]="showTagSelector"
    [style]="{ width: '500px', 'max-height': '700px' }"
    [modal]="true"
    (visibleChange)="onTagSelectorClosed()"
  >
    <div class="selector-container">
      <div *ngFor="let tag of tags">
        <p-checkbox [(ngModel)]="tag.selected" binary="true"></p-checkbox>
        <span class="tag-name">{{ tag.name }}</span>
        <div
          [ngClass]="{
            'tag-active': tag.inactiveDate == null,
            'tag-inactive': tag.inactiveDate != null
          }"
        >
          {{ tag.inactiveDate == null ? 'Active' : 'Inactive' }}
        </div>
        <div class="tag-description">{{ tag.description }}</div>
        <hr class="ui-widget-content tag-line" />
      </div>
    </div>
  </p-dialog>
</div>
<div *ngIf="readOnly && hasTags()">
  <div class="supplier-requires">Supplier requires:</div>
  <div *ngFor="let tagCol of tagColumns">
    <div *ngIf="tagSet[tagCol.index].length > 0">
      <div class="tag-section" *ngIf="tagCol.index > 1">Or</div>
      <div class="tag-section" *ngIf="tagCol.index == 0">But not</div>
      <div class="tag-name">{{ getTagDetails(tagCol.index) }}</div>
    </div>
  </div>
</div>
